import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { GET_GUIDE_PROFILE } from '../gql/guides-gql';
import Loader from '../common/Loader';
import GuideNav from './GuideNav';
import { Container } from '../../styles/Styles';

const ProfileContainer = styled.div`
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;
`;

const ProfileHeader = styled.h2`
    margin-bottom: 1.5rem;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.5rem;
`;

const ProfileDetail = styled.div`
    margin-bottom: 1rem;
    display: flex;
    align-items: center;

    strong {
        width: 120px;
        color: #555;
    }

    span {
        color: #333;
    }
`;

const GuideProfile = () => {
    const { data, loading, error } = useQuery(GET_GUIDE_PROFILE);

    if (loading) return <Loader />;
    if (error) return <p>Error loading profile: {error.message}</p>;

    const profile = data?.getGuideProfile;

    return (
        <Container>
            <GuideNav />
            <ProfileContainer>
                <ProfileHeader>Your Profile</ProfileHeader>
                {profile ? (
                    <>
                        <ProfileDetail>
                            <strong>First Name:</strong>
                            <span>{profile?.firstName}</span>
                        </ProfileDetail>
                        <ProfileDetail>
                            <strong>Last Name:</strong>
                            <span>{profile?.lastName}</span>
                        </ProfileDetail>
                        {/*<ProfileDetail>
                            <strong>Email:</strong>
                            <span>{profile?.email}</span>
                        </ProfileDetail>*/}
                        <ProfileDetail>
                            <strong>Languages:</strong>
                            <span>{profile?.languages?.join(', ')}</span>
                        </ProfileDetail>
                    </>
                ) : (
                    <p>Profile data not found.</p>
                )}

            </ProfileContainer>
        </Container>
    );
};

export default GuideProfile;
